<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height:525px" @click.stop>
                <div style="text-align:right">
                    <button class="transparent" type="button" @click="$emit('close')">
                        <img style="margin-top:5px;height:40px;padding-right:5px" :src="require('../assets/icon_clear.svg')"/>
                    </button>
                </div>
                <div style="text-align: center;">
                    <img style="height:470px;object-fit: scale-down;" :src="imageSrc"/>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
        }
    },
    created() {
    },
    props: [ 'imageSrc' ]
}
</script>
<style scoped>
.viewer {
    text-align: center;
    width: 100%;
    height: calc(100% - 35px);
}
</style scoped>
